// components/TextInput.tsx
import { useFormContext } from 'react-hook-form';

import type { GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '../ui/form';
import { Textarea } from '../ui/textarea';

type Props = {
  placeholder?: string;
  rows?: number;
} & GeneralFormProps;

function RHFShadcnTextarea({ ref, name, title, description, placeholder, required, value: externalValue, onChange: externalOnChange, rows, ...props }: Props & { ref?: React.RefObject<HTMLTextAreaElement | null> }) {
  const { control } = useFormContext<Record<string, string>>();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        // Destructure field properties to avoid passing incompatible types
        const { value, onChange, onBlur, name: fieldName, ref: fieldRef } = field;

        // Remove defaultValue from props if it exists
        const { defaultValue, ...restProps } = props;

        return (
          <FormItem className="mt-4 w-full">
            <FormControl>
              <Textarea
                name={fieldName}
                ref={ref || fieldRef}
                onBlur={onBlur}
                rows={rows !== undefined ? rows : undefined}
                required={required === true ? required : undefined}
                data-testid={fieldName}
                placeholder={placeholder}
                className="resize-none"
                onChange={(e) => {
                  if (externalOnChange !== undefined) {
                    externalOnChange(e);
                    return;
                  }
                  onChange(e);
                }}
                value={value ?? externalValue ?? ''}
                title={title}
                {...restProps}
              />
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}

RHFShadcnTextarea.displayName = 'RHFShadcnTextarea';

export default RHFShadcnTextarea;
